import Vue from 'vue';
import Vuex from 'vuex';
import router, { routes } from '../router';
import { TOKEN } from '@/utils'
import { currUser } from "@/api/system/user";
import { Message } from 'element-ui';

Vue.use(Vuex);

function getDefaultMenu(menus) {
    let firstMenu = menus.find(menu => menu.url === '/ticket/capture')
    if (!firstMenu) {
        for (const menu of menus) {
            if (menu.url && menu.url !== '') {
                firstMenu = menu
                break
            }
        }
    }

    return firstMenu
}

export default new Vuex.Store({
    state: {
        token: null,
        userInfo: null
    },
    getters: {
        getUserInfo(state) {
            return state.userInfo
        },
        getBtnPerms(state, getters) {
            return (perms) => {
                return getters.getUserInfo.role.menus.find(item => item.perms === perms)
            }
        }
    },
    mutations: {
        login(state, token) {
            state.token = token;
            sessionStorage.setItem(TOKEN, token);
        },
        logout(state) {
            state.token = "";
            sessionStorage.clear()
        },
        userInfo(state, payload) {
            state.userInfo = payload
            const menus = payload.role.menus
            if (menus && menus.length) {
                menus.forEach(item => {
                    let route = routes.find(r => r.path === item.url)
                    if (route) {
                        router.addRoute('首页', route)
                    }
                })
            }
        }
    },
    actions: {
        getUserInfo({ commit, getters }, currPath) {
            if (getters.userInfo) {
                const menus = getters['getUserInfo']['role']['menus']
                let firstMenu = getDefaultMenu(menus)
                if (currPath) {
                    router.replace(currPath);
                } else if (firstMenu) {
                    router.replace({ path: firstMenu.url, replace: true });
                } else {
                    router.push('/welcome');
                }
            } else {
                currUser().then((data) => {
                    commit("userInfo", data);
                }).then(() => {
                    const menus = getters['getUserInfo']['role']['menus']
                    let firstMenu = getDefaultMenu(menus)
                    if (currPath) {
                        router.replace(currPath);
                    } else if (firstMenu) {
                        router.replace({ path: firstMenu.url, replace: true });
                    } else {
                        router.push('/welcome');
                    }
                }).catch(err => {
                    Message.error(err)
                })
            }
        }
    }
})


// WEBPACK FOOTER //
// ./src/vuex/index.js